import { render, staticRenderFns } from "./DebugScreen.vue?vue&type=template&id=02c0bb27&scoped=true&"
import script from "./DebugScreen.vue?vue&type=script&lang=js&"
export * from "./DebugScreen.vue?vue&type=script&lang=js&"
import style0 from "./DebugScreen.vue?vue&type=style&index=0&id=02c0bb27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c0bb27",
  null
  
)

component.options.__file = "DebugScreen.vue"
export default component.exports